import React from 'react';

const Test: React.FC = () => {
  return <>TEST</>;
};

export default Test;
